// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__12ORZ","total":"Header_total__230x8","green":"Header_green__23bRj","red":"Header_red__3Iorg"};